import React from "react";
import K8S_plane from "../Images/K8S_plane.png";
import K8S_plane_llm from "../Images/K8S_plane_llm.png";
import K8S_llm_detail_2 from "../Images/K8S_llm_detail_2.png";
import llm_more_detail from "../Images/llm_more_detail.png";
import llm_more_detail_query_2 from "../Images/llm_more_detail_query_2.png";
import llm_more_detail_update_2 from "../Images/llm_more_detail_update_2.png";

// Shared styles for all diagrams
const diagramStyles = {
  container: {
    width: "100%",
    margin: "2rem 0",
    padding: "0",
    backgroundColor: "#ffffff",
    borderRadius: "0",
    border: "none",
  },
};

// Kubernetes Logo SVG (small inline icon)
export const K8sIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "inline-block", verticalAlign: "middle" }}
  >
    <path
      d="M16 2L3 9v14l13 7 13-7V9L16 2z"
      stroke="#111"
      strokeWidth="1.5"
      fill="none"
    />
    <circle cx="16" cy="16" r="4" stroke="#111" strokeWidth="1.5" fill="none" />
    <line x1="16" y1="12" x2="16" y2="6" stroke="#111" strokeWidth="1.5" />
    <line x1="16" y1="20" x2="16" y2="26" stroke="#111" strokeWidth="1.5" />
    <line x1="12.5" y1="14" x2="7" y2="11" stroke="#111" strokeWidth="1.5" />
    <line x1="19.5" y1="14" x2="25" y2="11" stroke="#111" strokeWidth="1.5" />
    <line x1="12.5" y1="18" x2="7" y2="21" stroke="#111" strokeWidth="1.5" />
    <line x1="19.5" y1="18" x2="25" y2="21" stroke="#111" strokeWidth="1.5" />
  </svg>
);

// 1. Control Plane Diagram
export const ControlPlaneDiagram = () => (
  <div style={diagramStyles.container}>
    <img 
      src={K8S_plane} 
      alt="Kubernetes Control Plane Architecture" 
      style={{ width: "100%", height: "auto" }}
    />
  </div>
);

// 2. Control Plane with LLM Observer
export const ControlPlaneWithLLMDiagram = () => (
  <div style={diagramStyles.container}>
    <img 
      src={K8S_plane_llm} 
      alt="LLM Agent Observing the Control Plane" 
      style={{ width: "100%", height: "auto" }}
    />
  </div>
);

// 3. LLM Component Detail
export const LLMDetailDiagram = () => (
  <div style={diagramStyles.container}>
    <img 
      src={K8S_llm_detail_2} 
      alt="LLM Agent Architecture" 
      style={{ width: "100%", height: "auto" }}
    />
  </div>
);

// 4. Security Sandbox Diagram
export const SecurityDiagram = () => (
  <div style={diagramStyles.container}>
    <img 
      src={llm_more_detail} 
      alt="Secure Sandbox Architecture" 
      style={{ width: "auto", height: "auto" }}
    />
  </div>
);

// 5. Query Audit Flow
export const QueryAuditDiagram = () => (
  <div style={diagramStyles.container}>
    <img 
      src={llm_more_detail_query_2} 
      alt="Query Audit Trail" 
      style={{ width: "50%", height: "auto" }}
    />
  </div>
);

// 6. Update Audit Flow
export const UpdateAuditDiagram = () => (
  <div style={diagramStyles.container}>
    <img 
      src={llm_more_detail_update_2} 
      alt="Update Operation with Rollback Support" 
      style={{ width: "50%", height: "auto" }}
    />
  </div>
);

export default {
  K8sIcon,
  ControlPlaneDiagram,
  ControlPlaneWithLLMDiagram,
  LLMDetailDiagram,
  SecurityDiagram,
  QueryAuditDiagram,
  UpdateAuditDiagram,
};
